/* assets/src/viewer/config/diff.js
 * Classifica un cambio di config per reagire al COSTO MINIMO:
 *  - topological : cambia modelType  -> rebuild completo (raro)
 *  - dimensional : cambia larghezza/sporgenza -> update geometria/scala minimo
 *  - aspect      : cambia colore/finitura -> update materiale in-place (cross-fade)
 *  - effects     : cambia un optional -> ricalcolo layer optional (no prezzo)
 */
import { parseStructureColor, parseFabricColor } from '../util.js';

const KNOWN_KEYS = new Set([
  'modelId', 'modelName', 'modelType', 'larghezza', 'sporgenza',
  'coloreStruttura', 'coloreTelo', 'coloreStrutturaText', 'coloreTeloText',
  'modelDefaultFov',
]);

export function normalizeConfig(config = {}) {
  const modelType = String(config.modelType || 'fabric');
  const larghezza = parseInt(config.larghezza || 300, 10) || 300;
  const sporgenza = parseInt(config.sporgenza || 200, 10) || 200;

  // Optional dinamici: tutto ciò che non è chiave nota e non è interno (__...).
  const optionals = {};
  Object.keys(config).forEach((k) => {
    if (KNOWN_KEYS.has(k) || k.startsWith('__')) return;
    optionals[k] = config[k];
  });

  return {
    modelType,
    modelId: config.modelId || null,
    larghezza,
    sporgenza,
    structColor: parseStructureColor(config.coloreStruttura),
    fabricColor: parseFabricColor(config.coloreTelo),
    optionals,
    optionalsSig: JSON.stringify(optionals),
    raw: config,
  };
}

export function classify(prevNorm, nextNorm) {
  if (!prevNorm) {
    return { topological: true, dimensional: true, aspect: true, effects: true, first: true };
  }
  const topological = prevNorm.modelType !== nextNorm.modelType;
  const dimensional = topological
    || prevNorm.larghezza !== nextNorm.larghezza
    || prevNorm.sporgenza !== nextNorm.sporgenza;
  const aspect = topological
    || prevNorm.structColor !== nextNorm.structColor
    || prevNorm.fabricColor !== nextNorm.fabricColor;
  const effects = topological || prevNorm.optionalsSig !== nextNorm.optionalsSig;
  return { topological, dimensional, aspect, effects, first: false };
}
